import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const QuoteMark = (props) => (
    <svg
        fill='none'
        height='36'
        viewBox='0 0 52 36'
        width='52'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M49.5368 0C43.9263 6.56842 40.3684 12.0421 38.8632 17.5158H39.6842C40.6421 16.5579 42.0105 16.1474 43.6526 16.1474C48.5789 16.1474 52 20.3895 52 25.8632C52 31.7474 47.3474 35.8526 40.9158 35.8526C34.3474 35.8526 29.1474 31.6105 29.1474 22.9895C29.1474 15.1895 33.1158 6.70527 38.7263 0H49.5368ZM20.3895 0C14.7789 6.56842 11.2211 12.0421 9.71579 17.5158H10.5368C11.4947 16.5579 12.8632 16.1474 14.5053 16.1474C19.4316 16.1474 22.8526 20.3895 22.8526 25.8632C22.8526 31.7474 18.2 35.8526 11.7684 35.8526C5.2 35.8526 0 31.6105 0 22.9895C0 15.1895 3.96842 6.70527 9.57895 0H20.3895Z'
            fill='currentColor'/>
    </svg>
);

export default QuoteMark;
